import { CONSTANTS } from "../core/constants";

export function validateInput(input : string, min : number, max : number) {
  if (input.length < min && input.length > max) {
    return false;
  }

  const matched = input.match(CONSTANTS.INPUT_REGEX);
  return (matched && matched.length > 0);
}

export function sanitizeInput(input : string, min : number, max : number) {
  return sanitizeWithRegex(input, min, max, CONSTANTS.INPUT_REGEX);
}

export function sanitizePassword(input : string, min : number, max : number) {
  return sanitizeWithRegex(input, min, max, CONSTANTS.WP_INPUT_REGEX);
}

function sanitizeWithRegex(input : string, min : number, max : number, regex : RegExp) {
  if (input.length < min && input.length > max) {
    return "";
  }

  const matched = input.match(regex);
  if (!matched || matched.length !== 1) {
    return "";
  }

  return matched[0];
}
